import { Reducer } from 'redux';
import { HomeProductsState, HomeProductsTypes } from './types';

const INITIAL_STATE: HomeProductsState = {
  data: [],
  config: [],
  loading: false,
};

const reducer: Reducer<HomeProductsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HomeProductsTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case HomeProductsTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload,
      };
    case HomeProductsTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default reducer;
